var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"page-footer"},[_vm._v(_vm._s(_vm.$t("footer.icp1"))+" "),_c('span',{staticClass:"icp-num"},[_vm._v(_vm._s(_vm.$t("footer.icp2")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }